import React from "react";
import "./Home.scss";
import Phone from "../../Animations/Phone/Phone";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import { ga_push } from "../../../services/analytics";
const Home = () => {
  const StartVote = () => {
    ga_push("navigation_events", "Navigation", "Start Voting");
    setPageView(1);
  };

  const { setPageView } = useContext(AppContext);

  return (
    <div className="home">
      <div className="page-wrapper">
        <div className="text">
          <div className="yellow-bar-wrapper">
            <div className="yellow-bar"></div>
          </div>
          <h2>המצעד</h2>
          <h2>הישראלי</h2>
          <h2>השנתי</h2>
          <h3>עם דלית רצ'שטר</h3>
        </div>
        <div className="mobile-only">
          <Phone />
        </div>
        <h4>
          זו לא הייתה שנה פשוטה לתעשיית המוזיקה הישראלית - אבל שירים היו לנו,
          ועכשיו הזמן להכתיר את הטובים ביותר:
        </h4>
        <h5>
          המצעד הישראלי השנתי של ynet וגלגלצ יוצא לדרך ואתם מוזמנים לבחור את
          השירים ואת האמנים שעשו לכם את השנה. סיימתם לדרג? ענו על החידון ואולי
          תזכו ברמקולים חכמים של
          <div className="sonos-text"></div>
          מתנת
          <div className="bug-text"></div>! קדימה - הצביעו, השפיעו ואל תשכחו
          להצטרף לשידור החי מאולפן ynet ביום חמישי,
          <div className="desktop-only">
            <br />
          </div>
          17 בספטמבר, בין השעות 14:00 - 18:00
        </h5>
        <button className="start-button" onClick={() => StartVote()}>
          התחילו להצביע
        </button>
      </div>
      <div className="desktop-only">
        <Phone />
      </div>
      {/* <Footer/> */}
    </div>
  );
};

export default Home;
